export enum CAMERA_FACING_MODE {
	USER = 'user',
	ENVIRONMENT = 'environment',
}